import React from "react";

import { combineClasses } from "@kikoff/utils/src/string";

import styles from "./view_template.module.scss";

interface ViewTemplateProps {
  className?: string;
  header?: React.ReactNode;
  note?: React.ReactNode;
  fullHeight?: boolean;
}

const ViewTemplate: React.FC<ViewTemplateProps> = ({
  header,
  className,
  note,
  children,
  fullHeight,
}) => {
  return (
    <div
      style={fullHeight ? { height: "100%" } : {}}
      className={combineClasses(styles["view-template"], className)}
    >
      {header && <header data-cy="view-template-header">{header}</header>}
      {note && <div className={styles.note}>{note}</div>}
      <div
        // TODO: find out if global content classname is being used, otherwise remove
        className={`${styles.content} content`}
      >
        {children}
      </div>
    </div>
  );
};

export default ViewTemplate;
